import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg)
  }
`;

const StyledLoadingContainer = styled.div<{ $size: 'small' | 'big' }>`
  height: 100%;
  width: 100%;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.color.bodyTextColor};
  font-size: ${({ $size }) => ($size === 'small' ? '14px' : '40px')};
`;

const StyledAnimatedSpinContainer = styled.div`
  transition: linear;
  animation-name: ${spin};
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
`;

const StyledIcon = styled.div`
  margin-bottom: 3rem;
`;

export { StyledLoadingContainer, StyledAnimatedSpinContainer, StyledIcon };
